import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import { isNativeApp } from './platform';

const APP_VIEWPORT =
    'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover';

function preventGestureZoom(event) {
    event.preventDefault();
}

/** Viewport auf Skala 1 festnageln (iOS Doppeltipp-Zoom trotz Capacitor `zoomEnabled: false`). */
export function lockAppPageZoom() {
    const meta = document.querySelector('meta[name="viewport"]');
    if (meta) {
        meta.setAttribute('content', APP_VIEWPORT);
    }
}

/** Statusleiste (helle Icons auf dunklem Header) und Splash ausblenden.
 *  Capacitor: Style.Dark = heller Text auf dunklem Grund (nicht Style.Light). */
export async function initNativeShell() {
    if (!isNativeApp()) {
        return;
    }

    lockAppPageZoom();
    document.addEventListener('gesturestart', preventGestureZoom, { passive: false });
    document.addEventListener('gesturechange', preventGestureZoom, { passive: false });
    document.addEventListener('gestureend', preventGestureZoom, { passive: false });

    try {
        await StatusBar.setStyle({ style: Style.Dark });
    } catch {
        // Plugin fehlt oder Plattform ohne Statusleiste
    }

    try {
        await SplashScreen.hide();
    } catch {
        // Launch-Splash ist bereits weg
    }
}
